'use strict';

/**
 * Hero Banner Shared Utilities
 * Common header height tracking for hero components
 *
 * @module utils/heroBannerUtils
 */

const HeroBannerUtils = {
    /**
     * Measure header sections and write height CSS vars to :root.
     * Used by hero slides for proper positioning with fixed/transparent headers.
     */
    updateHeaderHeights: function () {
        var header = document.querySelector('header');
        if (!header) return;

        var headerBanner = header.querySelector('.header-banner');
        var headerMobile = header.querySelector('.header-mobile');
        var headerDesktop = header.querySelector('.header-desktop');
        var promoBar = header.querySelector('.promo-bar');

        var bannerH = headerBanner ? headerBanner.offsetHeight : 0;
        var mobileH = headerMobile ? headerMobile.offsetHeight : 0;
        var desktopH = headerDesktop ? headerDesktop.offsetHeight : 0;
        var promoH = promoBar ? promoBar.offsetHeight : 0;

        document.documentElement.style.setProperty('--header-mobile-height', (bannerH + mobileH) + 'px');
        document.documentElement.style.setProperty('--header-desktop-height', (bannerH + desktopH) + 'px');
        document.documentElement.style.setProperty('--promo-bar-height', promoH + 'px');
        document.documentElement.style.setProperty('--nav-mobile-height', mobileH + 'px');
        document.documentElement.style.setProperty('--nav-desktop-height', desktopH + 'px');
    },

    /**
     * Initialize header height tracking
     * Attaches event listeners for load and resize
     */
    initHeaderHeightTracking: function () {
        window.addEventListener('load', this.updateHeaderHeights.bind(this));
        window.addEventListener('resize', this.updateHeaderHeights.bind(this));
    }
};

// Auto-initialize header height tracking once
HeroBannerUtils.initHeaderHeightTracking();

// Export for use in other modules
module.exports = HeroBannerUtils;
